import React, { useEffect, useState } from "react";
import CommonModal from "../../ResetContext/components/DumpModal";
import { useAppServices } from "../../../../../hook/services";
import toast from "react-hot-toast";

const EditBillingInfoModal = ({
  isOpen,
  onClose,
  paymentMethod_id,
  billing_details = {},
  setRefetch,
  userActiveLocation
}) => {

  const service = useAppServices();
  const [form, setForm] = useState({
    name: billing_details.name || "",
    email: billing_details.email || "",
    phone: billing_details.phone || "",
    line1: billing_details.address?.line1 || "",
    line2: billing_details.address?.line2 || "",
    city: billing_details.address?.city || "",
    state: billing_details.address?.state || "",
    postal_code: billing_details.address?.postal_code || "",
    country: billing_details.address?.country || "",
  });
  const [loading, setLoading] = useState(false);

  const handleChange = (e) => {
    setForm({ ...form, [e.target.name]: e.target.value });
  };

  useEffect(() => {
    if (billing_details) {
      setForm({
        name: billing_details.name || "",
        email: billing_details.email || "",
        phone: billing_details.phone || "",
        line1: billing_details.address?.line1 || "",
        line2: billing_details.address?.line2 || "",
        city: billing_details.address?.city || "",
        state: billing_details.address?.state || "",
        postal_code: billing_details.address?.postal_code || "",
        country: billing_details.address?.country || "",
      });
    }
  }, [billing_details]);

  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);

    const payload = {
      paymentMethod_id,
      billing_details: {
        address: {
          line1: form.line1,
          line2: form.line2,
          city: form.city,
          state: form.state,
          postal_code: form.postal_code,
          country: form.country,
        },
        name: form.name,
        email: form.email,
        phone: form.phone,
      },
      customer_id: userActiveLocation?.customer_id
    };

    const { response } = await service.subscription.updateBillingInfoByStripeId(
      { payload }
    );
    if (response?.data) {
      toast.success("Billing information updated!");
      setLoading(false);
      setRefetch && setRefetch((r) => !r);
      onClose();
      return;
    }
    toast.error("Failed to update billing information");
    setLoading(false);
  };

  return (
    <CommonModal
      title="Edit Billing Information"
      showAlert={false}
      isOpen={isOpen}
      onClose={onClose}
    >
      <form onSubmit={handleSubmit} className="space-y-3 p-2 overflow-y-auto max-h-[80vh]">
        <div>
          <label className="block text-sm mb-1">Name</label>
          <input
            name="name"
            value={form.name}
            onChange={handleChange}
            className="w-full border rounded px-2 py-1"
            type="text"
            required
          />
        </div>
        <div>
          <label className="block text-sm mb-1">Email</label>
          <input
            name="email"
            type="email"
            value={form.email}
            onChange={handleChange}
            className="w-full border rounded px-2 py-1"
            required
          />
        </div>
        <div>
          <label className="block text-sm mb-1">Phone</label>
          <input
            name="phone"
            type="text"
            value={form.phone}
            onChange={handleChange}
            className="w-full border rounded px-2 py-1"
          />
        </div>
        <div>
          <label className="block text-sm mb-1">Address Line 1</label>
          <input
            name="line1"
            type="text"
            value={form.line1}
            onChange={handleChange}
            className="w-full border rounded px-2 py-1"
            required
          />
        </div>
        <div>
          <label className="block text-sm mb-1">Address Line 2</label>
          <input
            name="line2"
            type="text"
            value={form.line2}
            onChange={handleChange}
            className="w-full border rounded px-2 py-1"
          />
        </div>
        <div>
          <label className="block text-sm mb-1">City</label>
          <input
            name="city"
            type="text"
            value={form.city}
            onChange={handleChange}
            className="w-full border rounded px-2 py-1"
            required
          />
        </div>
        <div>
          <label className="block text-sm mb-1">State</label>
          <input
            name="state"
            type="text"
            value={form.state}
            onChange={handleChange}
            className="w-full border rounded px-2 py-1"
            required
          />
        </div>
        <div>
          <label className="block text-sm mb-1">Postal Code</label>
          <input
            name="postal_code"
            type="text"
            value={form.postal_code}
            onChange={handleChange}
            className="w-full border rounded px-2 py-1"
            required
          />
        </div>
        <div>
          <label className="block text-sm mb-1">Country</label>
          <input
            name="country"
            type="text"
            value={form.country}
            onChange={handleChange}
            className="w-full border rounded px-2 py-1"
            required
          />
        </div>
        <button
          type="submit"
          disabled={loading}
          className="w-full bg-black text-white py-2 mt-2 rounded"
        >
          {loading ? "Saving..." : "Save Billing Info"}
        </button>
      </form>
    </CommonModal>
  );
};

export default EditBillingInfoModal;
